import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickSyncDownloadHistoryQueryApi } from "@/features/pathpick/features/sync-download-history/api/query";
import { PathPickProductRequestListParams } from "@/features/pathpick/types/request-params";
import { PathPickProductRequestListResponse } from "@/features/pathpick/types/response";
import { hasPendingProductRequest } from "@/features/pathpick/utils/request";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 처리 중 항목이 있을 때만 폴링하는 주기 (ms)
const POLL_INTERVAL_MS = 5000;

// 상품별 처리 내역 조회 훅 — 모달 전용이라 열려 있을 때만(enabled) 조회한다.
// 페이지/필터 전환 시 이전 목록을 유지해 전체 플래시를 막는다.
//
// 쿼리 키에 companyId를 앞에 두어야 useCreatePathPickRequests의
// ["pathpick","requests",companyId] 무효화가 prefix로 이 쿼리까지 덮는다.
const useGetPathPickProductRequests = (
  params?: PathPickProductRequestListParams,
  enabled = true
) => {
  const { companyId } = useCompanyIdentity();

  const {
    data: pathPickProductRequests,
    isPending,
    isPlaceholderData,
  } = useQuery({
    queryKey: ["pathpick", "requests", companyId, "product-list", params],
    queryFn: async () => {
      const data =
        await pathPickSyncDownloadHistoryQueryApi.getPathPickProductRequests(
          companyId as number,
          params
        );
      return toCamelKeyObject(data) as PathPickProductRequestListResponse;
    },
    enabled: Boolean(companyId) && enabled,
    placeholderData: keepPreviousData,
    // 신청 직후엔 서버가 처리 결과를 비동기로 채우므로 종료될 때까지 재조회한다.
    refetchInterval: (query) =>
      hasPendingProductRequest(query.state.data) ? POLL_INTERVAL_MS : false,
  });

  return { pathPickProductRequests, isPending, isPlaceholderData };
};

export default useGetPathPickProductRequests;
